import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Explore from './icon-explore.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Explore {...validProps} />;
}
SvgComponent.iconName = 'explore';

/**
 * @deprecated This is a legacy icon
 */
export const ExploreIcon = svgIconWrapper(SvgComponent);
